import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Disclaimer from '../Disclaimer';
import { view04ImageOptions } from './views/view04'

class Wheels extends Component {
    constructor(props) {
		super(props);
		this.handleWheelChange = this.handleWheelChange.bind(this);
    }

	handleWheelChange(newValue) {
		let configuration = this.props.configuration;
		configuration.Wheel = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = view04ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Wheels' /></h1>
					<p><Trans defaults='The electronic equipment shown on this render is optional. Please contact your local dealer for further information.' /></p>
					<RadioGroup label="Options:" options={this.props.wheelOptions} value={this.props.configuration.Wheel} onChange={this.handleWheelChange} />

                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Wheels);


// WEBPACK FOOTER //
// ./src/X43MK2/Wheels.js